import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { Header } from './components/Header';
import { HeroModern } from './components/HeroModern';
import { SmartHomeVisualizerModern } from './components/SmartHomeVisualizerModern';
import { Features } from './components/Features';
import { Benefits } from './components/Benefits';
import { Solutions } from './components/Solutions';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import '@/App.css';

// Home Page Component
const HomePage = () => (
  <>
    <HeroModern />
    <SmartHomeVisualizerModern />
    <Features />
    <Benefits />
    <Solutions />
    <FAQ />
    <Contact />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
